interface DiscountRateInputProps {
  productId: string;
  discountRate: number;
  type: 'deadline' | 'reservation';
  isRandomBox?: boolean;
  onChange: (productId: string, discountRate: number) => void;
  disabled?: boolean;
}

export function DiscountRateInput({
  productId,
  discountRate,
  type,
  isRandomBox,
  onChange,
  disabled = false
}: DiscountRateInputProps) {
  // 할인율 제한 설정
  const getDiscountLimits = () => {
    if (type === 'deadline') {
      if (isRandomBox) {
        return { min: 50, max: 50, fixed: true }; // 랜덤박스는 50% 고정
      }
      return { min: 40, max: 80, fixed: false }; // 일반 상품은 40-80%
    }
    // 예약할인: 0-10%
    return { min: 0, max: 10, fixed: false };
  };

  const limits = getDiscountLimits();

  return (
    <div>
      <label className="block text-sm text-gray-600 mb-1">
        할인율
        {limits.fixed && <span className="text-xs text-gray-500 ml-1">(고정)</span>}
      </label>
      
      {limits.fixed ? (
        <div className="flex items-center">
          <span className="px-3 py-1.5 bg-gray-100 border border-gray-300 rounded-lg text-sm text-gray-700">
            {discountRate}%
          </span>
          <span className="ml-2 text-xs text-gray-500">
            랜덤박스는 50% 고정 할인입니다
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => {
              const step = type === 'deadline' ? 5 : 1;
              const newRate = Math.max(limits.min, discountRate - step);
              onChange(productId, newRate);
            }}
            disabled={disabled || discountRate <= limits.min}
            className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-md bg-white disabled:bg-gray-100 disabled:text-gray-400 hover:bg-gray-50"
          >
            -
          </button>
          
          <input
            type="number"
            min={limits.min}
            max={limits.max}
            step={type === 'deadline' ? 5 : 1}
            value={discountRate}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value >= limits.min && value <= limits.max) {
                onChange(productId, value);
              }
            }}
            disabled={disabled}
            className="w-16 px-2 py-1.5 text-center border border-gray-300 rounded-md text-sm disabled:bg-gray-100 disabled:text-gray-500"
          />
          <span className="text-sm text-gray-600">%</span>
          
          <button
            type="button"
            onClick={() => {
              const step = type === 'deadline' ? 5 : 1;
              const newRate = Math.min(limits.max, discountRate + step);
              onChange(productId, newRate);
            }}
            disabled={disabled || discountRate >= limits.max}
            className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-md bg-white disabled:bg-gray-100 disabled:text-gray-400 hover:bg-gray-50"
          >
            +
          </button>
        </div>
      )}
      
      {!limits.fixed && (
        <p className="text-xs text-gray-500 mt-1">
          {type === 'deadline' 
            ? '마감할인: 최소 40% 이상 할인'
            : '예약할인: 0-10% 권장 (5-10% 추천)'}
        </p>
      )}
    </div>
  );
}